// async types
export const FETCH_CREATE_SCREEN_SIZES = 'screenSizes/FETCH_CREATE_SCREEN_SIZES';
export const FETCH_REMOVE_SCREEN_SIZES = 'screenSizes/FETCH_REMOVE_SCREEN_SIZES';

// sync types
export const SET_SCREEN_SIZES = 'screenSize/SET_SCREEN_SIZES';
